<template>
  <table-layout>
    <template v-slot:title></template>
    <template v-slot:button></template>
    <template v-slot:table>
      <v-data-table
        height="65vh"
        :headers="getHeader(deleteMemberHeader)"
        :items="deletedMemberList"
        no-data-text="조회된 데이터가 없습니다"
        :items-per-page="-1"
        fixed-header
        mobile-breakpoint="md"
      >
        <template v-slot:item.hireDate="{ value }">
          <div>{{ setDashDate(value) }}</div>
        </template>
        <template v-slot:item.delDate="{ value }">
          <div>{{ setTableDateFormat(value) }}</div>
        </template>
        <template v-slot:item.restore="{ item }">
          <v-btn class="button" outlined @click="isRestoreMember(item)">복구</v-btn>
        </template>
      </v-data-table>
    </template>
  </table-layout>
</template>
<script>
import TableLayout from "@/common/layout/TableLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import {DELETE_MEMBER_LIST_TABLE} from "@/util/TableHeaders";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "DeleteMemberList",
  components: {TableLayout},
  props: ["deleteTabs"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      deleteMemberHeader: DELETE_MEMBER_LIST_TABLE,
      deletedMemberList: []
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  watch: {
    deleteTabs(value) {
      if (value === 1) {
        this.getDeleteMemberList();
      }
    }
  },
  mounted() {
    this.getDeleteMemberList();
  },
  methods: {
    async getDeleteMemberList() {
      this.deletedMemberList = [];
      try {
        const { data } = await axiosInstance.get("/private/member/list", {
          params: {
            memberId: this.memberId,
            delYn: "Y",
          }
        });
        if (data.length < 1) {
          this.deletedMemberList = [];
          return false;
        } else {
          this.deletedMemberList = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    isRestoreMember(memberData) {
      this.showConfirm({
        message: `${memberData.memberNm}님을 복구 하시겠습니까?`,
        successCallback: () => {
          this.restoreMember(memberData);
        },
        failCallback: () => {
          return false;
        }
      });
    },
    async restoreMember(memberData) {
      try {
        await axiosInstance.delete("/admin/member", {
          params: {
            adminId: this.memberId,
            memberId: memberData.memberId,
            delYn: "N"
          }
        }).then(() => {
          this.showAlert({
            message: "복구가 완료되었습니다",
            successCallback: () => {
              this.$emit("refresh");
              this.getDeleteMemberList();
            }
          })
        })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>